module.exports = __webpack_public_path__ + "img/dis-wu.81d54560.svg";